<ng-container>
    <button mat-mini-fab class="product-card-action"
        (click)="onClick($event)"
        *ngIf="data.admin"
        [matTooltip]="tooltip">
        <mat-icon>bookmark_add</mat-icon>
    </button>
</ng-container>
